import React from 'react';
import { useAITTheme } from '../ui/theme';

const HistoryIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M93.18,50c0,23.85-19.33,43.18-43.18,43.18S6.82,73.85,6.82,50,26.15,6.82,50,6.82s43.18,19.33,43.18,43.18ZM50,0c27.61,0,50,22.39,50,50s-22.39,50-50,50S0,77.61,0,50,22.39,0,50,0ZM52.27,19.32c-1.88,0-3.41,1.53-3.41,3.41v28.41h-27.28c-1.88,0-3.41,1.53-3.41,3.41s1.53,3.41,3.41,3.41h30.69c1.88,0,3.41-1.53,3.41-3.41v-31.82c0-1.88-1.53-3.41-3.41-3.41Z"
      />
    </svg>
  );
};

export default HistoryIcon;
